import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

// components
import AppCard from 'src/components/AppCard.js'
import AppCardHeader from 'src/components/card/AppCardHeader'
import AppDetails from 'src/components/details/coupon-details/AppDetails'
import AppFirstDetails from 'src/components/details/brand-details/AppFirstDetails'
import AppSecondDetails from 'src/components/details/brand-details/AppSecondDetails'
import AppModalConfirmation from 'src/components/modal/AppModalConfirmation'

// helpers
import Axios from 'src/helpers/axios'

const CouponDetails = () => {
  const navigate = useNavigate()
  const params = useParams()
  const { id } = params

  const [couponDetails, setCouponDetails] = useState('')
  const [showConfirmDelete, setShowConfirmDelete] = useState({ show: false, item: {} })

  const handleCardHeaderButton = () => {
    navigate(`/coupons/edit/${id}`)
    window.location.reload();
  }

  useEffect(() => {
    fetchCouponDetails(id)
  }, [id]);

  const fetchCouponDetails = (id) => {
    Axios({
      method: "get",
      url: `/api/ecommerce/v1/promotions/id/${id}`,
    })
      .then(({ data }) => {
        setCouponDetails(data)
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const handleDeleteConfirmation = (item) => {
    Axios({
      method: "delete",
      url: `/api/ecommerce/v1/promotions/remove/${item.id}`,
    })
      .then(({ data }) => {
        setShowConfirmDelete({ show: false, item: {} })
        navigate(`/coupons/list`)
      })
      .catch((err) => {
        console.error(err);
      });
  }

  return (
    <>
    {showConfirmDelete.show && (
      <AppModalConfirmation
        confirmationType='delete-item'
        itemName='coupon'
        itemDetails={showConfirmDelete.item}
        showModal={showConfirmDelete}
        setShowModal={setShowConfirmDelete}
        handleConfirmation={handleDeleteConfirmation}
      />
    )}
    <AppCard
      className='mt-4 mb-4'
      headerTitle={
        <AppCardHeader
          id={id}
          headerTitle={<h4>Coupon Details</h4>}
          headerButton="Edit"
          handleCardHeaderButton={handleCardHeaderButton}
          headerDeleteButton={true}
          setShowConfirmDelete={setShowConfirmDelete}
        />
      }
      bodyContent={
        <AppDetails
          couponDetails={couponDetails}
        />
      }
    />
    </>
  )
}

export default CouponDetails
